/* jshint esversion: 6, -W097 */
/* globals module */
'use strict';

/**
 * SavedSearchesService is responsible for making account my searches page api calls and model level calculations
 * 
 * @module enervee_utils.account
 */

SavedSearchesService.$inject = [
    '$q',
    'AccountSideNavService',
    'FiltersService',
    'UserApiConsumerService',
    'CmsContentService',
    'GetFetchService',
];

function SavedSearchesService(
    $q,
    AccountSideNavService,
    FiltersService,
    UserApiConsumerService,
    CmsContentService,
    GetFetchService
) {
    var _pub = {},
        _savedSearches;

    CmsContentService.retrieveCMSContent('filters');

    /**
     * Get the saved searches
     *
     * @returns {*}
     */
    _pub.getSavedSearches = () => _savedSearches;

    /**
     * Fetches the saved searches for the currently logged in user
     *
     * @returns {*}
     */
    _pub.fetchSavedSearches = function (force) {
        force = force || false;
        const urlOptions = {
            url: 'api/1.0/user-profile/saved-search/',
            requestingService: UserApiConsumerService.request
        };
        const getFetchOptions = {
            force: force,
            responseReturnFunction: (response) => updateMinMaxDisplayNames(response.data || []),
        };
        return GetFetchService.get(
            'user-profile-saved-searches',
            urlOptions,
            getFetchOptions
        ).then((savedSearches) => {
            _savedSearches = savedSearches;
            AccountSideNavService.updateSideNavSearchesCount(_savedSearches.length);
        }, () => {
            _savedSearches = [];
            AccountSideNavService.updateSideNavSearchesCount(0);
        });
    };

    /**
     * Given an array of saved searches, returns the same array with the display names of
     * min/max filters updated using CMS text, if any exists.
     * 
     * @param {Array<Object>} savedSearches
     * @return {Promise<Array<Object>>}
     */
    function updateMinMaxDisplayNames(savedSearches) {
        return $q.all({
            min: CmsContentService.getMarketPlaceText('filters:saved_search_min'),
            max: CmsContentService.getMarketPlaceText('filters:saved_search_max'),
        }).then((cmsText) => {
            if (!cmsText.min && !cmsText.max) return savedSearches;
            
            return savedSearches.map((savedSearch) => {
                if (!savedSearch.filters_display) return savedSearch;

                savedSearch.filters_display = savedSearch.filters_display.map((displayName) => {
                    if (cmsText.min && displayName.startsWith('Min ')) {
                        return displayName.replace(/Min /i, cmsText.min + ' ');
                    }
                    if (cmsText.max && displayName.startsWith('Max ')) {
                        return displayName.replace(/Max /i, cmsText.max + ' ');
                    }
                    return displayName;
                });

                return savedSearch;
            });
        });
    }

    /**
     * removes a saved search based on the given saved search id and
     * then gets the updated search list
     *
     * @param savedSearchId
     * @returns {*}
     */
    _pub.removeSavedSearch = function (savedSearchId) {
        return UserApiConsumerService.delete(
            'api/1.0/user-profile/saved-search/' + savedSearchId + '/'
        ).then(function (response) {
            var force = true;
            // Clear the endpoint where we get saved search counts from
            GetFetchService.clear('profile-info');
            return _pub.fetchSavedSearches(force);
        });
    };

    /**
     * Either returns the saved search object for this search, or null if the
     * current filters aren't saved by the user
     * 
     * @param {Array<Object>} savedSearches
     * @param {Object} savedSearches[].filters
     * @return {Object|null}
     */
    _pub.getCurrentSearchIfSaved = function (savedSearches) {
        if (!savedSearches) {
            return;
        }

        let currentFilters = Object.assign({}, FiltersService.currentFilters());
        let match = null;
        let savedSearch;
        let itemMatched = (_savedFilterVals) => (val, i) =>  val === _savedFilterVals[i];

        for (var i=0; i<savedSearches.length; i+=1) {
            savedSearch = savedSearches[i];
            match = savedSearch;
            if (JSON.stringify(Object.keys(currentFilters).sort()) !== JSON.stringify(Object.keys(savedSearch.filters).sort())) {
                match = null;
            }

            for (var key in currentFilters) {
                if (Array.isArray(currentFilters[key]) && Array.isArray(savedSearch.filters[key])) {
                    const currentFilterVals = currentFilters[key].sort();
                    const savedFilterVals = savedSearch.filters[key].sort();
                    const filterValsLengthMatch = currentFilterVals.length === savedFilterVals.length;
                    const same = (filterValsLengthMatch && currentFilterVals.every(itemMatched(savedFilterVals)));

                    if (!same) {
                        match = null;
                    }
                } else if (currentFilters[key] != savedSearch.filters[key]) {
                    match = null;
                }
            }

            if (match) {
                return match;
            }
        }
        return null;
    }

    return _pub;
}

module.exports = SavedSearchesService;
